{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -24.285985714113423,
              66.81818862222948
            ],
            [
              -26.308759766727377,
              65.12416398172076
            ],
            [
              -20.061083786532834,
              62.390620143473285
            ],
            [
              -10.998477321192041,
              63.69963664833318
            ],
            [
              -11.602620833875022,
              67.1731299797535
            ],
            [
              -24.285985714113423,
              66.81818862222948
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}